import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger('kycListTable');
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import { PaginationTable } from '../../../components/tables/paginationTable';
import TableFilters from './tableFilter';

import { TableCell, Box, List, ListItem, MenuItem, styled, useTheme, TextField, Button, Select } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { configFile } from '../../../config';
import { Icon } from '@iconify/react';
import moment from 'moment';

const columns = [
    { id: 'plan_id', label: 'Plan ID', minWidth: 100, align: 'center' },
    { id: 'title', label: 'Title', minWidth: 150, align: 'center' },
    { id: 'country', label: 'Country', minWidth: 100, align: 'center' },
    { id: 'create_date', label: 'Created Date', minWidth: 100, align: 'center' },
    { id: "deduction_type", label: "Deduction Type", minWidth: 120, align: 'center' },
    { id: 'single_part_english_char_limit', label: 'Single English Char', minWidth: 150, align: 'center' },
    { id: 'single_part_unicode_char_limit', label: 'Single Unicode Char', minWidth: 150, align: 'center' },
    { id: 'multi_part_english_char_limit', label: 'Multi English Char', minWidth: 150, align: 'center' },
    { id: 'multi_part_unicode_char_limit', label: 'Multi Unicode Char', minWidth: 150, align: 'center' },
    { id: 'transactional_sms_price', label: 'Trans', minWidth: 100, align: 'center' },
    { id: 'promotional_sms_price', label: 'Promo', minWidth: 100, align: 'center' },
    { id: 'explicit_sms_price', label: 'Explicit', minWidth: 100, align: 'center' },
    { id: 'implicit_sms_price', label: 'Implicit', minWidth: 100, align: 'center' },
    { id: 'dlt_sms_price', label: 'DLT', minWidth: 100, align: 'center' },
    { id: 'reseller_over_selling_x', label: 'Reseller', minWidth: 180, align: 'center' },
    { id: 'actions', label: 'Actions', minWidth: 70, align: 'center' },
    ];


export const SmsPlanTable = ({ loadit, setUpdateUserId, forceLoad }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);

  const [search, setSearch] = useState('');
  const [load, setLoad] = useState(true);
  const [networkError, setNetworkError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleChange = (value) => setSearch(value);

  const getGatewayList = async () => {
    const skip = rowsPerPage * page;
    try {
      const params = { skip, limit: rowsPerPage };
      if (search) params.searchPlanId = search;
      setNetworkError(false);
      const { planList, totalDocuments } = await axiosGetCall('getSmsPlansList', params);
      setRows(planList);
      setCount(totalDocuments);
    } catch (error) {
      logger.error('Gateway List', error);
      setNetworkError(true);
      setRows([]);
      setCount(0);
      renderErrorMessage(error?.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    // if (load) {
    setLoading(true);
    getGatewayList();
    setLoad(false);
    forceLoad(false);

    // }
  }, [load, loadit]);

  const handleClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setUserData(user);
  };
  const handleUpdateClick = () => {
    setAnchorEl(null);
    setUpdateUserId(userData.gateway_id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  const tableFilter = (
    <TableFilters search={search} handleChange={handleChange} setLoad={setLoad} count={count} setPage={setPage} />
  );

  const ActionJsx = (id, align, value, ...other) => {
    const user = other[3];

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          size: 'small',
        }}
      >
        <MoreVertIcon
          sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
          aria-controls={open ? 'filters-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(e) => handleClick(e, user)}
        />
      </TableCell>
    );
  };
  const Content = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <List>
        <ListItem
          sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: 'pointer',
            },
          }}
          onClick={handleUpdateClick}
        >
          <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
          Update
        </ListItem>
      </List>
    </Box>
  );

  const createdatejsx = (id, align, value) => {
    const date = moment(Number(value)*1000);
    const formattedDate = date.format('D MMM, YYYY');
    const formattedTime = date.format('h:mm A');
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}
      >
        <>
          <Box>{value !== '' ? `${formattedDate} ${formattedTime}` : '-'}</Box>
        </>
      </TableCell>
    );
  };
  const routeJsx = (id, align, value) => {
    const ROUTE_LABELS = {
      transactional: 'Transactional',
      promotional: 'Promotional',
      explicit: 'Explicit',
      implicit: 'Implicit',
    };
    const label = ROUTE_LABELS[value] || value;

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          background: 'transparent',
        }}
      >
        {label}
      </TableCell>
    );
  };


  const ActionModals = () => {
    return <CustomMenu anchorEl={anchorEl} handleClose={handleClose} Content={Content} />;
  };
  return (
    <>
      <PaginationTable
        page={page}
        tableFilter={tableFilter}
        // ActionJsx={ActionJsx}
        // ActionModals={ActionModals}
        setLoad={setLoad}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        count={count}
        error={networkError}
        loading={loading}
        setLoading={setLoading}
        rows={rows}
        columns={columns}
        handleChange={handleChange}
        search={search}
        calculatedHeight={288}
        routeJsx={routeJsx}
        createdatejsx={createdatejsx}
      />
    </>
  );
};
